/* Revisão 9 fiel: apresentação ligada aos campos nativos. Não envia pedidos.
   v7: à vista com a conta do servidor do checkout; cabeçalho não congela sem painel.
   v9: quantidade nunca passa do estoque disponível (ajustar). */
(function () {
  function fmt(c) { return (c / 100).toLocaleString('pt-BR', {style:'currency',currency:'BRL'}); }

  // VALOR A VISTA — arredonda ao centavo, como o servidor do checkout que cobra o
  // Pix (round2(subtotal * 0.90) em lib/payments-verify.js). Aqui a conta e em
  // centavos inteiros: (preco * qtd * 9 + 5) / 10.
  // Bate com o servidor em TODOS os precos da loja hoje (1.272 de 1.272 casos).
  // Excecao conhecida: o servidor faz a conta em ponto flutuante e, quando a
  // fracao cai exatamente em meio centavo (preco terminado em 5 centavos, ex.
  // R$ 10,45), as vezes arredonda para BAIXO. Nesses casos a pagina mostra 1
  // centavo A MAIS do que o Pix cobra — nunca a menos. A correcao definitiva e
  // o checkout passar a contar em centavos inteiros tambem.
  // A conta vai sobre o TOTAL. Multiplicar o a vista de uma unidade pela
  // quantidade (como o v6 fazia) diverge do Pix em ate 2 centavos.
  function avista(centavos, q) { return Math.floor((centavos * q * 9 + 5) / 10); }

  // precoVariante: centavos da variante escolhida, vindo do evento do tema. Usado
  // quando a pagina nao tem o painel de preco (templates sem bloco de parcelamento),
  // para o cabecalho nao congelar — o defeito de 16/09 que ja voltou uma vez.
  // QUANTIDADE DENTRO DO QUE EXISTE. O campo traz max = estoque disponivel quando a
  // loja nao vende sem estoque (snippets/buy-buttons.liquid). Sem este ajuste, pedir
  // 50 de um produto com 11 mostrava "Total para 50 unidades" — numero que o carrinho
  // ia recusar depois. O ajuste acontece ao SAIR do campo (evento change), nunca a
  // cada tecla: quem digita "11" nao pode ver o valor mudar no meio da digitacao.
  function ajustar(input) {
    if (!input) return 1;
    var min = Math.floor(Number(input.min)) || 1;
    var max = Math.floor(Number(input.max));
    var q = Math.floor(Number(input.value));
    if (!Number.isFinite(q) || q < min) q = min;
    if (Number.isFinite(max) && max > 0 && q > max) q = max;
    if (String(q) !== String(input.value)) {
      input.value = String(q);
      // avisa o seletor do tema (ele liga/desliga os botoes + e -)
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
    return q;
  }

  function update(precoVariante, targetRoot) {
    (targetRoot ? [targetRoot] : document.querySelectorAll('product-info')).forEach(function(root) {
      var inventory=root.querySelector('[id^="Inventory-"]');
      var form=root.querySelector('product-form.product-form--buy-buttons');
      if(inventory&&form&&form.previousElementSibling!==inventory)form.before(inventory);
      var panel=root.querySelector('.isafe-pv9-price-panel');
      var unit=panel?Number(panel.dataset.unitPrice):Number(precoVariante);

      // Cabecalho PRIMEIRO e fora de qualquer condicao do painel.
      var top=root.querySelector('#pv9-topo-preco');
      if(top&&Number.isFinite(unit)&&unit>0)top.textContent=fmt(avista(unit,1));

      if(!panel)return;
      var cashEl=panel.querySelector('.ip-parcelas__cash-val');
      if(!cashEl)return;
      var input=root.querySelector('.isafe-pv9-quantity-row input[name="quantity"]');
      var q=ajustar(input);
      cashEl.textContent=fmt(avista(unit,q));
      var inst=panel.querySelector('.ip-parcelas__val');
      if(inst)inst.textContent=fmt(Math.ceil(unit*q/10));
      panel.querySelector('[data-pv9-total]').textContent=fmt(unit*q);
      panel.querySelector('.isafe-pv9-price-label').textContent=q>1?'Total para '+q+' unidades':'';panel.querySelector('.isafe-pv9-price-label').hidden=q===1;
      var compare=panel.querySelector('[data-pv9-compare]');
      if(compare)compare.textContent=fmt(Number(panel.dataset.unitCompare)*q);
    });
  }
  document.addEventListener('change',function(e){if(e.target.matches('.isafe-pv9-quantity-row input[name="quantity"]'))update(null,e.target.closest('product-info'));});
  function alignMedia(root,id){
    if(!id)return;
    var gallery=root.querySelector('media-gallery');
    if(!gallery||typeof gallery.setActiveMedia!=='function')return;
    gallery.setActiveMedia(root.dataset.section+'-'+id,false);
  }
  if(typeof subscribe==='function')subscribe('variant-change',function(event){
    var data=event&&event.data;
    var root=data&&document.getElementById('MainProduct-'+data.sectionId);
    if(root)update(data&&data.variant?data.variant.price:null,root);
    if(root&&data.variant&&data.variant.featured_media){root.dataset.pv6MediaId=data.variant.featured_media.id;alignMedia(root,data.variant.featured_media.id);}
  });
  function alignInitial(){customElements.whenDefined('media-gallery').then(function(){requestAnimationFrame(function(){document.querySelectorAll('product-info[data-pv6-media-id]').forEach(function(root){alignMedia(root,root.dataset.pv6MediaId);});});});}
  if(document.readyState==='complete')alignInitial();else window.addEventListener('load',alignInitial,{once:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){update(null);});else update(null);
})();

function ipdToggle(id) {
  var c = document.getElementById('ipd-' + id);
  var f = document.getElementById('ipd-fade-' + id);
  var b = document.getElementById('ipd-btn-' + id);
  if (!c) return;
  var expanded = c.classList.contains('ipd--expanded');
  if (expanded) {
    c.classList.remove('ipd--expanded');
    f.classList.remove('ipd--hidden');
    b.classList.remove('ipd--expanded');
    b.setAttribute('aria-expanded','false');
    b.innerHTML = 'Mostrar mais <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  } else {
    c.classList.add('ipd--expanded');
    f.classList.add('ipd--hidden');
    b.classList.add('ipd--expanded');
    b.setAttribute('aria-expanded','true');
    b.innerHTML = 'Mostrar menos <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';
  }
}
